/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { StackHDownIcon16Light } from './StackHDownIcon16Light';
import { StackHDownIcon16Regular } from './StackHDownIcon16Regular';
import { StackHDownIcon16Solid } from './StackHDownIcon16Solid';
import { StackHDownIcon20Light } from './StackHDownIcon20Light';
import { StackHDownIcon20Regular } from './StackHDownIcon20Regular';
import { StackHDownIcon20Solid } from './StackHDownIcon20Solid';
import { StackHDownIcon24Regular } from './StackHDownIcon24Regular';
import { StackHDownIcon24Solid } from './StackHDownIcon24Solid';
import { StackHDownIcon32Regular } from './StackHDownIcon32Regular';
import { StackHDownIcon64Regular } from './StackHDownIcon64Regular';
var sizes = {
    16: {
        light: StackHDownIcon16Light,
        regular: StackHDownIcon16Regular,
        solid: StackHDownIcon16Solid,
    },
    20: {
        light: StackHDownIcon20Light,
        regular: StackHDownIcon20Regular,
        solid: StackHDownIcon20Solid,
    },
    24: {
        regular: StackHDownIcon24Regular,
        solid: StackHDownIcon24Solid,
    },
    32: {
        regular: StackHDownIcon32Regular,
    },
    64: {
        regular: StackHDownIcon64Regular,
    },
};
export var StackHDownIcon = forwardRef('StackHDownIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
